import React, { useEffect, useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import '../css/app.css'

let linkTags = []
const IsolateContent = () => {
   
    return (
        <>
            <Outlet />
        </>
    );
};


export default IsolateContent;